import RecycleScroller from './RecycleScroller.vue'

export { RecycleScroller }
